import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-not-found',
  templateUrl: './m-not-found.component.html'
})
export class MNotFoundComponent {}
